import React, { useEffect, useContext } from 'react'
import { func } from 'prop-types'
import styled from 'styled-components'

import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import Heading from 'components/buy/Engraving/Heading'
import EngravingOption from 'components/buy/Engraving/EngravingOption'
import List from 'components/buy/Engraving/List'
import BuyDevices from 'components/buy/BuyDevices'

import * as spacing from 'styles/spacing'
import { media } from 'styles/media'

const Colors = styled.div`
  margin-bottom: ${spacing.large};

  ${media.medium`
    margin-bottom: ${spacing.xLarge};
  `};

  ${media.large`
    margin-bottom: ${spacing.xxLarge};
  `};

  ${media.xLarge`
    margin-bottom: ${spacing.xxxLarge};
  `};
`

const InitialStep = ({ setStep, devices, collectionTitle, handleDeviceSelect }) => {
  const { engraving, currentView, setCurrentView } = useContext(EngravingContext)
  const { front } = engraving

  useEffect(() => {
    setCurrentView({ ...currentView, item: 'front', step: 'initialstep' })
  }, [])

  return (
    <>
      <Heading number="01" title="Pick device colour & design style" />
      <Colors>
        <BuyDevices devices={devices} collectionTitle={collectionTitle} handleDeviceSelect={handleDeviceSelect} />
      </Colors>

      <List row={3}>
        {Object.keys(front).map((key, idx) => {
          if (typeof front[key] === 'object') {
            return (
              <EngravingOption
                key={idx}
                onClick={() => {
                  setStep(key)
                }}
                name={front[key].displayName}
                figure={front[key].slug}
                isLarge
              />
            )
          }
        })}
      </List>
    </>
  )
}

InitialStep.propTypes = {
  setStep: func.isRequired
}

export default InitialStep
